import { defineMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';
import * as yup from 'yup';

const enterAnnualTurnover = defineMessage({
    id: '_.your_company.error.enter_annual_turnover',
    defaultMessage: 'Please enter your annual turnover'
});

const enterAnnualProfit = defineMessage({
    id: '_.your_company.error.enter_annual_profit',
    defaultMessage: 'Please enter your annual profit'
});

const enterTradingFrom = defineMessage({
    id: '_.your_company.error.enter_trading_from',
    defaultMessage: 'Please enter the date you began trading'
});

type CompanyType = { value: string };

export const createCompanySchema = (
    intl: IntlShape,
    companyType: CompanyType,
    country: string
) => {
    const tradingFromMessage = intl.formatMessage(enterTradingFrom);

    const tradingFrom = yup.object({
        day: yup.string().required(tradingFromMessage),
        month: yup.string().required(tradingFromMessage),
        year: yup.string().required(tradingFromMessage)
    });

    const annualTurnover = yup
        .string()
        .required(intl.formatMessage(enterAnnualTurnover));

    if (companyType.value === 'sole_trader') {
        return yup.object({
            annualTurnover,
            tradingFrom,
            ...(country === 'UK' && {
                annualProfit: yup
                    .string()
                    .required(intl.formatMessage(enterAnnualProfit))
            })
        });
    }

    return yup.object({
        annualTurnover,
        tradingFrom
    });
};
